import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminSettingsEnrollNewCompanyParam } from "features/admin/core/admin.params";
import { AxiosError } from "axios";
import {
  AdminSettingsEnrollNewCompanyRepository,
  AdminSettingsEnrollNewCompanyResponse,
} from "features/admin/data/repository/admin.repository";
import { RootState } from "features/config/store";

export enum AdminSettingsEnrollNewCompanyState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: AdminSettingsEnrollNewCompanyState;
  message: string;
}

const initialState: InitialState = {
  status: AdminSettingsEnrollNewCompanyState.initial,
  message: "",
};

export const adminSettingsEnrollNewCompany = createAsyncThunk(
  "adminSettingsEnrollNewCompany",
  async (param: AdminSettingsEnrollNewCompanyParam, { rejectWithValue }) => {
    try {
      const response: AdminSettingsEnrollNewCompanyResponse =
        await AdminSettingsEnrollNewCompanyRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const adminSettingsEnrollNewCompanySlice = createSlice({
  name: "adminSettingsEnrollNewCompany",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminSettingsEnrollNewCompany.pending, (state) => {
        state.status = AdminSettingsEnrollNewCompanyState.inProgress;
      })
      .addCase(adminSettingsEnrollNewCompany.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;

          state.status = AdminSettingsEnrollNewCompanyState.success;
          state.message = message;
        }
      })
      .addCase(adminSettingsEnrollNewCompany.rejected, (state, action) => {
        state.status = AdminSettingsEnrollNewCompanyState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectAdminSettingsEnrollNewCompany = (state: RootState) =>
  state.adminSettingsEnrollNewCompany;

export default adminSettingsEnrollNewCompanySlice.reducer;
